import { render, staticRenderFns } from "./parent-form-page.vue?vue&type=template&id=12e228cb&"
import script from "./parent-form-page.vue?vue&type=script&lang=js&"
export * from "./parent-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports